var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"path-1_5_","d":"m247.471 0h176.765v424.236h-176.765z","transform":"translate(9 2)","key":0}),React.createElement("path",{"id":"path-1_4_","d":"m0 0h176.765v424.236h-176.765z","transform":"translate(2 2)","key":1})]);
}

Pause.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 424.236 424.236","height":"512","viewBox":"0 0 424.236 424.236","width":"512"};

module.exports = Pause;

Pause.default = Pause;
